"use strict";
var WindowUtils = (function () {
    function WindowUtils() {
    }
    WindowUtils.setDirty = function (value, withPjax) {
        if (value === void 0) { value = true; }
        if (withPjax === void 0) { withPjax = true; }
        if (window.onbeforeunload && value) {
            return;
        }
        window.onbeforeunload = value
            ? function () { return true; }
            : null;
        if (withPjax) {
            var self = this;
            $(document).off('pjax:beforeSend', self.confirmFunc);
            if (value) {
                $(document).on('pjax:beforeSend', null, { msg: self.beforeUnloadMessage, confirmCallback: self.setDirty }, self.confirmFunc);
            }
        }
    };
    WindowUtils.beforeUnloadMessage = "Внесенные изменения не сохранятся. Продолжить?";
    WindowUtils.confirmFunc = function (event) {
        if (window.onbeforeunload) {
            var choice = confirm(event.data.msg);
            if (choice) {
                event.data.confirmCallback(false, true);
            }
            return choice;
        }
    };
    return WindowUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = WindowUtils;
//# sourceMappingURL=windowUtils.js.map